import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { ClientSources } from '#/api/models'

type ClientSourceParam = { clientSource?: string }

export const useClientSource = () => {
  const { clientSource: clientSourceRouteParamValue } = useParams<ClientSourceParam>()

  const getClientSource = useCallback((): ClientSources => {
    if (!clientSourceRouteParamValue) {
      return ClientSources.Browser
    }

    const clientSource = Object.entries(ClientSources).find(
      ([key]) => key.toLowerCase() === clientSourceRouteParamValue.toLowerCase()
    )?.[1]

    if (!clientSource) {
      return ClientSources.Browser
    }

    return clientSource
  }, [clientSourceRouteParamValue])

  return {
    getClientSource
  }
}
